import { render } from "./AptNewsView.vue?vue&type=template&id=3365ddfc&ts=true"
import script from "./AptNewsView.vue?vue&type=script&lang=ts"
export * from "./AptNewsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__